import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const DelRoute = ({ userRole }) => {
  const navigate = useNavigate();

  // Restrict access to Movers only
  useEffect(() => {
    if (userRole !== 'Mover') {
      navigate('/login', { replace: true });
    }
  }, [userRole, navigate]);

  if (userRole !== 'Mover') {
    return null;
  }

  return (
    <div className="delroute-page" style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
      <h2 style={{ fontSize: '24px', color: '#333', marginBottom: '20px' }}>Delivery Route</h2>
      <p style={{ fontSize: '16px', color: '#666' }}>
        This is the Delivery Route page, accessible to Movers. Add functionality for managing delivery routes here.
      </p>
    </div>
  );
};

export default DelRoute;